import React from 'react';
import { Clock, Pickaxe, Swords, Footprints, Shield, Skull } from 'lucide-react';
import { number } from './CommunityShared';
import s from './Community.module.css';

export function formatPlaytime(seconds) {
  if (seconds == null) return '—';
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor(total % 3600 / 60);
  if (hours > 0) return `${number(hours)} ч ${minutes} мин`;
  return `${minutes} мин ${total % 60} с`;
}

/** Keep account and public profiles in sync with all six stored player_stats fields. */
export default function PlayerStatistics({ stats, compact = false }) {
  const value = key => stats[key] == null ? '—' : number(stats[key]);
  const entries = [
    [Clock, formatPlaytime(stats.playtimeSeconds), 'Время в игре'],
    [Pickaxe, value('blocksBroken'), 'Добыто блоков'],
    [Swords, value('mobsKilled'), 'Убито мобов'],
    [Footprints, value('blocksWalked'), 'Пройдено блоков'],
    [Shield, value('playersKilled'), 'Убито игроков'],
    [Skull, value('deaths'), 'Смерти'],
  ];
  return <div className={`${s.statGrid} ${compact ? s.statsCompact : s.statsFull}`} aria-label="Статистика игрока">
    {entries.map(([Icon, value, label]) => <div className={s.stat} key={label}>
      <Icon size={21} aria-hidden="true" />
      <strong>{value}</strong>
      <span>{label}</span>
    </div>)}
  </div>;
}
